module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getPositionClass()
  }, [_c('div', {
    staticClass: "border"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65201310!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/stickyNotifications/index.vue
// module id = 371
// module chunks = 2